import React from 'react';
import CreateEditHappiness from '../../../components/Happiness/CreateEditHappiness';
import { addHappiness } from '../../../utils/api_calls';

const CreateHappiness = () => {
  return <CreateEditHappiness submitHappiness={addHappiness} />;
};

export default CreateHappiness;
